import { InvestmentsFilterDto, InvestmentsListQueryDto } from '@dealstack/shared/lib/generated';
import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting.ts';
import { toIdListFilterValue } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils.ts';
import {
	EligibilityFilter,
	ManageInvestmentsTableColumn,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/investment.types.ts';

export const mapInvestmentsTableFilterToDto = (
	dataOperations: TableOperations<InvestmentsListQueryDto>,
	eligibilityFilter?: EligibilityFilter
): InvestmentsFilterDto => {
	const isReleased =
		dataOperations.quickFilters?.isReleased !== undefined
			? dataOperations.quickFilters.isReleased === true
			: undefined;

	const investmentWorkflowId =
		dataOperations.filter?.[ManageInvestmentsTableColumn.investmentWorkflowId];

	const investorIds = toIdListFilterValue(
		dataOperations.filter?.[ManageInvestmentsTableColumn.investorId]
	);

	return {
		isReleased:
			eligibilityFilter === EligibilityFilter.INVITE ||
			eligibilityFilter === EligibilityFilter.REVOKE ||
			eligibilityFilter === EligibilityFilter.TRANSACTION_TYPE ||
			eligibilityFilter === EligibilityFilter.UPDATE_ALLOCATIONS
				? false
				: isReleased,
		investorSearch:
			dataOperations.filter?.[ManageInvestmentsTableColumn.investor] ||
			dataOperations.search ||
			undefined,
		createdDate: dataOperations.filter?.[ManageInvestmentsTableColumn.createdAt],
		updatedDate: dataOperations.filter?.[ManageInvestmentsTableColumn.updatedAt],
		investmentWorkflowType: dataOperations.filter?.[ManageInvestmentsTableColumn.type],
		paymentStatus: dataOperations.filter?.[ManageInvestmentsTableColumn.payment],
		investmentStatus: dataOperations.filter?.[ManageInvestmentsTableColumn.status],
		securityIds: dataOperations?.filter?.[ManageInvestmentsTableColumn.allocations],
		mipClassifierIds: dataOperations?.filter?.[ManageInvestmentsTableColumn.cohorts],
		kycStatus: dataOperations.filter?.[ManageInvestmentsTableColumn.kyc],
		contractStatus: dataOperations.filter?.[ManageInvestmentsTableColumn.contracts],
		isEligibleForRelease: eligibilityFilter === EligibilityFilter.RELEASE ? true : undefined,
		isEligibleForAllocationsUpdate:
			eligibilityFilter === EligibilityFilter.UPDATE_ALLOCATIONS ? true : undefined,
		investmentWorkflowIds: investmentWorkflowId ? [investmentWorkflowId] : undefined,
		investorIds: investorIds.length ? investorIds : undefined,
	};
};
